(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.leaderboardSwiper = {
    attach: function (context, settings) {
      once("leaderboardSwiper", ".swiper-leaderboard", context).forEach(function (element) {
        var that = $(element);

        new Swiper($(element)[0], {
          loop: true,
          pagination: {
            el: that.find(".swiper-pagination")[0],
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
